<template>
  <div class="clock-display">
    <video autoplay muted loop playsinline class="video-bg">
      <source src="@/assets/background-video.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div class="content-overlay">
      <!-- <h1 class="subject-text">
        {{ store.subject || "Waiting for Input..." }}
      </h1> -->

      <div class="current-time">
        {{ currentTime }}
      </div>
      <div class="content-overlay">
        <div class="thai-date mb-2">{{ currentThaiDate }}</div>
      </div>

      <div class="details-section mt-4">
        <v-row>
          <v-col cols="12" sm="6" align-start justify-start>
            <ul>
              <li
                class="pa-2 ms-5 text-start"
                v-for="(item, index) in store.ExtraDetails"
                :key="index"
              >
                {{ item }}
              </li>
            </ul>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useClockStore } from "@/stores/clock";
const store = useClockStore();
const currentTime = ref("");
import axios from "axios";
import { doc } from "firebase/firestore";
let serverOffset = 0; // Difference in milliseconds

const syncWithServer = async () => {
  try {
    const start = Date.now();
    // Fetch from YOUR server, which fetched from the Internet
    const response = await axios.get("/api/network-time");
    const data = await response.data;
    const source = data.source || "local";
    const clockText = document.querySelector(".current-time");
    if (source === "internet") {
      clockText.style.color = "black"; // Black text for Internet
    } else {
      clockText.style.color = "#F06292"; // Pink text for Local
    }

    const latencies = (Date.now() - start) / 2;
    const serverTime = new Date(data.datetime).getTime() + latencies;

    serverOffset = serverTime - Date.now();
    console.log("Synced with Internet via Proxy. Offset:", serverOffset);
  } catch (e) {
    console.error("Total sync failure:", e);
    serverOffset = 0;
  }
};

let timer;
onMounted(async () => {
  await syncWithServer(); // Sync once at start
  updateTime();
  timer = setInterval(updateTime, 1000);
});
const currentThaiDate = ref("");

const updateTime = () => {
  const now = new Date(Date.now() + serverOffset);

  // Format Time
  currentTime.value = now.toLocaleTimeString("en-GB", { hour12: false });

  // Format Thai Date (B.E.)
  currentThaiDate.value = new Intl.DateTimeFormat("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
  }).format(now);
};
</script>
<style scoped>
.clock-display {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: black; /* Fallback color */
}

.video-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  /* This is the magic property. It acts like 'background-size: cover' for images */
  object-fit: contain;
  /* If you want to see the WHOLE video frame without any cropping at all,
     use 'contain', but you will have black bars on the sides/top. */
}

.content-overlay {
  position: relative;
  text-align: center;
  text-shadow: 3px 3px 10px rgba(0, 0, 0, 0.8);
  color: white;

  /* FIXED: Ensure content never goes off-screen */
  width: 90vw; /* Keep a 5% margin on each side */
  max-width: 1200px; /* Don't let it get ridiculously wide on ultra-wide screens */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.current-time {
  /* FIXED: Use vw (viewport width) so text scales with screen size */
  font-size: min(15vw, 12rem);
  font-weight: bold;
  line-height: 1;
  transition: all 0.5s ease; /* Smooth transition for size/color changes */
}

.thai-date {
  font-size: min(4vw, 3rem);
  font-weight: 500;
  margin-bottom: 1rem;
  color: black;
}

.details-section {
  width: 100%;
  display: flex;
  justify-content: center;
}
ul {
  list-style-position: inside;
  padding: 0;
  text-align: left; /* Keep text left, but the whole UL is centered */
  font-size: min(2.5vw, 2rem);
}
</style>
